import React from "react";
import { Page } from "../../common/components/Page";
import { LostUnitsEdit } from "./LostUnitsEdit";

export const LostUnitsEditPage: React.FC = () => {
  return <Page content={LostUnitsEdit} title="Edit Lost Units" />;
};
